import React, { useEffect, useRef } from 'react';
import cls from './Option.module.css';
import classNames from 'classnames';
import { OptionBalance } from './OptionBalance';

export const Option = ({ option, onClick, setIsOpen, isAccount, isBold }) => {
    const optionRef = useRef(null);
    const handleClick = (clickedValue, event) => {
        if (!option.isDisabled) {
            if (option.isButton) {
                option.buttonHandler();
            } else {
                onClick(clickedValue);
                setIsOpen(false);
            }
        } else {
            event.stopPropagation();
        }
    };

    useEffect(() => {
        const option = optionRef.current;
        if (!option) return;

        const handleEnterPress = (event) => {
            if (document.activeElement === option && event.key === 'Enter') {
                onClick(option.value);
            }
        };

        option.addEventListener('keydown', handleEnterPress);

        return () => {
            option.removeEventListener('keydown', handleEnterPress);
        };
    }, [option.value, onClick]);

    return (
        <li
            ref={optionRef}
            className={classNames(
                cls.option,
                {
                    [cls.head]: option.isHead,
                    [cls.disabledOption]: option.isDisabled,
                    [cls.dimmedOption]: option.isDimmed,
                    [cls.button]: option.isButton,
                    [cls.padding]: !!option.isPadding,
                },
                [isBold]
            )}
            value={option.value}
            onClick={(e) => handleClick(option.value, e)}
            tabIndex={0}
        >
            <span className={classNames(cls.svgWrapper)}>{!!option.icon && option.icon}</span>

            <span className={classNames(cls.optionSpan)}>
                {option.title}
                {isAccount && <OptionBalance accountBalance={option.balance} />}
            </span>
        </li>
    );
};
